import { FC } from "react";
import {
  Box,
  Heading,
  UnorderedList,
  OrderedList,
  ListItem,
  Text,
  Image,
  Flex,
  Icon,
  Button,
  SimpleGrid,
  GridItem,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { IoIosCheckmarkCircle } from "react-icons/io";

import AffiliateImage from "../assets/images/affiliateImage.png";
import LogoIcon from "../assets/images/logoIcon.png";

export const Affiliate: FC = () => {
  const navigate = useNavigate();

  return (
    <Box p={{ base: "16px", lg: "80px" }} maxW={"1400px"} mx="auto">
      <Flex justify={"space-between"} align={"center"} mb="48px">
        <Button
          bg={"#FF8E3C"}
          _hover={{ bg: "#FF8E3C" }}
          h="58px"
          fontSize={{ base: "16px", lg: "20px" }}
          fontFamily={"RedHatDisplay-Bold"}
          borderRadius={"38px"}
          color={"white"}
          alignSelf={"flex-start"}
          onClick={() =>
            window.open("https://forms.gle/pPCo4Pm7HTGBwUzM6", "_blank")
          }
        >
          Join Now
        </Button>

        <Image src={LogoIcon} />
      </Flex>

      <SimpleGrid
        templateColumns={{ base: "1fr", lg: "1fr 600px" }}
        gap={"0px"}
      >
        <GridItem>
          <Box mb="60px">
            <Heading
              fontSize={{ base: "24px", lg: "40px" }}
              color={"#000"}
              fontFamily={"RedHatDisplay-Bold"}
              fontWeight={900}
            >
              Book-d Affiliate Program
            </Heading>

            <Heading
              mt="24px"
              color={"#000"}
              fontSize={{ base: "18px", lg: "24px" }}
              fontFamily={"RedHatDisplay-Bold"}
              fontWeight={900}
              textTransform={"uppercase"}
            >
              Exclusive perks
            </Heading>

            <UnorderedList
              spacing={{ base: "24px", lg: "36px" }}
              mt={{ base: "24px", lg: "36px" }}
              color={"#000"}
              fontSize={{ base: "16px", lg: "18px" }}
            >
              <ListItem>
                Earn up to £50 per referral! Get rewarded for every stylist you
                refer to our Premium plan.
              </ListItem>

              <ListItem>
                Simple & tiered rewards: Earn £10 just for a sign-up, with the
                potential for more rewards as your referred stylist becomes
                active.
              </ListItem>

              <ListItem>
                Help stylists grow: By referring stylists to Book-d, you're not
                just earning; you're helping them streamline their business and
                succeed.
              </ListItem>
            </UnorderedList>
          </Box>

          <Heading
            color={"#000"}
            fontSize={{ base: "18px", lg: "24px" }}
            fontFamily={"RedHatDisplay-Bold"}
            fontWeight={900}
            textTransform={"uppercase"}
          >
            How it works
          </Heading>

          <Flex gap={{ base: "20px", lg: "48px" }} mt="36px" flexDir={"column"}>
            <Flex gap={{ base: "4px", lg: "12px" }}>
              <Icon boxSize={"40px"} color="teal.200">
                <IoIosCheckmarkCircle />
              </Icon>

              <Box>
                <Text fontSize={"16px"} mb={{ base: "6px", lg: "16px" }}>
                  Sign Up for Free
                </Text>

                <Text fontSize={"13px"}>
                  Join our affiliate family in just minutes
                </Text>
              </Box>
            </Flex>

            <Flex gap={{ base: "4px", lg: "12px" }}>
              <Icon boxSize={"40px"} color="teal.200">
                <IoIosCheckmarkCircle />
              </Icon>

              <Box>
                <Text fontSize={"16px"} mb={{ base: "6px", lg: "16px" }}>
                  Complete the Form
                </Text>

                <Text fontSize={"13px"}>
                  Complete the online form with details of the hair stylist you
                  have referred
                </Text>
              </Box>
            </Flex>

            <Flex gap={{ base: "4px", lg: "12px" }}>
              <Icon boxSize={"40px"} color="teal.200">
                <IoIosCheckmarkCircle />
              </Icon>

              <Box>
                <Text fontSize={"16px"} mb={{ base: "6px", lg: "16px" }}>
                  Share & Promote
                </Text>

                <Text fontSize={"13px"}>
                  Tell your hairstylist about Book-d and get them to sign up on
                  the Book-d Pro app
                </Text>
              </Box>
            </Flex>
          </Flex>
        </GridItem>

        <GridItem justifySelf={"center"}>
          <Flex flexDir={"column"}>
            <Image src={AffiliateImage} />

            <Button
              bg={"#FF8E3C"}
              _hover={{ bg: "#FF8E3C" }}
              mt={{ base: "-8px", lg: "-36px" }}
              borderRadius={"30px"}
              color={"white"}
              h="58px"
              fontSize={{ base: "16px", lg: "20px" }}
              fontFamily={"RedHatDisplay-Bold"}
              onClick={() =>
                window.open("https://forms.gle/pPCo4Pm7HTGBwUzM6", "_blank")
              }
              alignSelf={"center"}
            >
              REFER A STYLIST
            </Button>
          </Flex>
        </GridItem>
      </SimpleGrid>

      <Box mt="96px" color={"#000"} maxW={"900px"}>
        <Heading
          fontSize={{ base: "18px", lg: "24px" }}
          fontFamily={"RedHatDisplay-Bold"}
          fontWeight={900}
          textTransform={"uppercase"}
        >
          Terms And Conditions
        </Heading>

        <Flex
          flexDir={"column"}
          gap={{ base: "12px", lg: "24px" }}
          fontSize={{ base: "12px", lg: "14px" }}
          mt={{ base: "16px", lg: "32px" }}
        >
          <Text>
            Welcome to the Book-d Affiliate Programme. By participating in this
            programme, you agree to be bound by the following terms and
            conditions.
          </Text>

          <OrderedList spacing={{ base: "12px", lg: "24px" }}>
            <ListItem>
              <Heading fontSize={"14px"} mb="12px">
                Programme Overview
              </Heading>
              <Text>
                The Book-d Affiliate Programme allows you to earn rewards by
                referring new hairstylists to sign up for a Book-d Premium or
                Book-d Starter plan. Your earnings are based on the successful
                signup and continued activity of the referred stylist.{" "}
              </Text>
            </ListItem>

            <ListItem>
              <Heading fontSize={"14px"} mb="12px">
                How to Refer a Stylist
              </Heading>
              <Text>
                To refer a new hairstylist, you must submit your details and the
                stylist's details using the designated Google Form:
                https://forms.gle/pPCo4Pm7HTGBwUzM6. The referral will only be
                considered valid if the stylist has not previously signed up for
                a Book-d account and signs up for a paid plan within 90 days of
                your submission.
              </Text>
            </ListItem>

            <ListItem gap={"12px"}>
              <Heading fontSize={"14px"} mb="12px">
                Referral Rewards
              </Heading>

              <Text>
                The total reward you can earn per referred stylist depends on
                the plan they sign up for and their activity on the platform.
                All payments will be made to you via your preferred method.
              </Text>

              <Heading fontSize={"14px"} my="12px">
                Book-d Premium Plan Referrals
              </Heading>

              <Text>
                For each referred stylist who signs up for a Book-d Premium
                plan, you have the potential to earn up to £50, paid out in
                three stages:
              </Text>

              <UnorderedList mt="12px" spacing={"12px"}>
                <ListItem>
                  <b>£10</b> upon the referred stylist's successful signup and
                  completion of the onboarding process.
                </ListItem>

                <ListItem>
                  +<b>£15</b> after the first month of verified activity, which
                  is defined as the stylist completing their first paid booking.
                </ListItem>

                <ListItem>
                  +<b>£25</b> after the second month of continued usage on the
                  Book-d Premium plan, or when the stylist reaches a booking
                  threshold of <b>£250</b> worth of bookings, whichever comes
                  first.
                </ListItem>
              </UnorderedList>

              <Heading fontSize={"14px"} my="12px">
                Book-d Starter Plan Referrals
              </Heading>

              <Text>
                For each referred stylist who signs up for a Book-d Starter
                plan, you have the potential to earn up to £25, paid out in two
                stages:
              </Text>

              <UnorderedList mt="12px" spacing={"12px"}>
                <ListItem>
                  <b>£10</b> upon the referred stylist's successful signup and
                  completion of the onboarding process.
                </ListItem>

                <ListItem>
                  +<b>£15</b> after the first month of verified activity, which
                  is defined as the stylist completing their first paid booking.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem>
              <Heading fontSize={"14px"} mb="12px">
                Payment Conditions
              </Heading>

              <UnorderedList spacing={"12px"}>
                <ListItem>
                  All rewards are subject to a verification process by Book-d to
                  confirm the stylist's eligibility and activity.
                </ListItem>

                <ListItem>
                  Payments will be processed within 30 days after each reward
                  milestone is met.
                </ListItem>

                <ListItem>
                  You are responsible for any taxes associated with the rewards
                  you earn from this programme.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem>
              <Heading fontSize={"14px"} mb="12px">
                Programme Limitations
              </Heading>

              <UnorderedList spacing={"12px"}>
                <ListItem>You cannot refer yourself.</ListItem>

                <ListItem>
                  Book-d reserves the right to disqualify any referral we
                  suspect to be fraudulent or in violation of these terms.
                </ListItem>

                <ListItem>
                  Book-d reserves the right to modify or terminate this
                  programme and these terms and conditions at any time without
                  prior notice.
                </ListItem>

                <ListItem>
                  Rewards have no cash value outside of the programme and are
                  non-transferable.
                </ListItem>
              </UnorderedList>
            </ListItem>

            <ListItem>
              <Heading fontSize={"14px"}>Acceptance</Heading>

              <Text my="12px">
                By participating in the Book-d Affiliate Programme, you
                acknowledge that you have read, understood, and agreed to these
                terms and conditions
              </Text>

              <Text>
                For any questions regarding the affiliate programme, please
                contact us at <b>info@book-d.co.uk</b>
              </Text>
            </ListItem>
          </OrderedList>
        </Flex>

        <Flex mt="48px" flexDir={"column"} gap={{ base: "12px", lg: "24px" }}>
          <Heading
            fontSize={{ base: "18px", lg: "24px" }}
            fontFamily={"RedHatDisplay-Bold"}
            fontWeight={900}
            textTransform={"uppercase"}
          >
            What can you share with the stylists
          </Heading>

          <Text fontSize={"14px"}>
            The dedicated stylist onboarding page below will give you all the
            information you need to share with the stylists that you refer and
            provide you with the tools to get them fully onboarded on the
            platform.
          </Text>

          <Button
            bg={"#FF8E3C"}
            _hover={{ bg: "#FF8E3C" }}
            h="58px"
            px="60px"
            fontSize={{ base: "16px", lg: "20px" }}
            fontFamily={"RedHatDisplay-Bold"}
            borderRadius={"38px"}
            color={"white"}
            alignSelf={"flex-start"}
            onClick={() => navigate("/why-affiliate")}
          >
            VIEW GUIDE
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
